<template>
  <view>
    <text>做以下任务可以免费获取积分，积分可以兑换VIP时长</text>
    <el-card shadow="hover" style="margin-left: 10px;margin-top: 10px;width: 97%" header="邀请好友">
      <el-row>
        <el-col :span="14">
          <text>发送小程序的邀请码给好友，好友点击后即可获取积分。</text>
          <br>
          <text>每个新用户增加300积分(分享的好友将额外增加100积分,初始用户为30积分)</text>
          <br>
          <text>分享给同一好友，只在此好友首次进入才获取积分。</text>
          <br>
        </el-col>
        <el-col :span="10">
          <text style="margin-left: 20px">请使用微信小程序分享</text>
          <br>
          <img src="@/assets/picture/weChatMini.jpg"
               style="width: 150px;height: 150px; margin-left: 30px;"
               alt="mini"/>
        </el-col>
      </el-row>


    </el-card>
    <el-card shadow="hover" style="margin-left: 10px;margin-top: 10px;width: 97%" header="反馈建议">
      <text>对系统有更好的建议和想法，帮助系统更好的成长。</text>
      <br>
      <text>待系统试题组采纳建议后即可增加积分，每个有效建议增加300积分。</text>
      <br>
      <el-button type="success" size="small" style="float: right;" @click="toFeedBackPage('suggestion')">
        去建议
      </el-button>
    </el-card>
    <el-card shadow="hover" style="margin-left: 10px;margin-top: 10px;width: 97%" header="反馈试题">
      <text>反馈试题是否考过，帮助其他考生更快通过考试。请在对应题目中的反馈按钮中进行反馈。</text>
      <br>
      <text>每天限制10题，每题增加30积分，多出的反馈试题不增加积分。</text>
    </el-card>
    <el-card shadow="hover" style="margin-left: 10px;margin-top: 10px;width: 97%" header="纠错试题">
      <text>试题纠错，待系统试题组确认试题确实有问题，即可增加积分。</text>
      <br>
      <text>每题增加500积分，请在对应题目中的反馈按钮中进行反馈。</text>
    </el-card>

    <el-dialog v-model="showFeedBack" title="反馈" append-to-body>
      <feedBackComponent :chooseType="feedBackType" @submitFeedBack:value="handleFeedBackDialog"></feedBackComponent>
    </el-dialog>
  </view>


</template>

<script>
import {
  ref
} from "vue";
import {useRoute} from "vue-router/dist/vue-router";
import {ElMessage} from "element-plus";
import router from "@/router";
import feedBackComponent from "@/components/FeedBack";


const showFeedBack = ref(false);
const shareFromUserId = ref('');
let loginUserId = localStorage.getItem("loginUserId");
const feedBackType = ref('suggestion');

export default {
  name: "PointCardTask",
  components: {feedBackComponent},
  created() {
    const route = useRoute();
    shareFromUserId.value = route.query.from;
    if (shareFromUserId.value === '' || shareFromUserId.value === null || shareFromUserId.value === undefined) {
      return;
    }

    if (loginUserId === '') {
      ElMessage.success("额外增加100积分");
      setTimeout(() => {
        router.push("/login?shareFromUser=" + shareFromUserId.value);
      }, 2000);
    } else {
      ElMessage.warning("朋友点击后可获得积分，继续获取积分");
    }
  },
  data() {
    return {
      showFeedBack: showFeedBack,
      feedBackType: feedBackType
    }
  },
  methods: {
    toFeedBackPage(type) {
      feedBackType.value = type;
      showFeedBack.value = true;
    },

    handleFeedBackDialog(value) {
      if (value === 'success') {
        showFeedBack.value = false;
      }
    },
  }
}
</script>

<style scoped>

</style>
